import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBellRingingFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.97143 3.7774C7.40076 3.42999 7.46717 2.80032 7.11976 2.37099C6.77234 1.94166 6.14267 1.87525 5.71334 2.22266C4.64066 3.09068 3.75095 4.17645 3.1114 5.41361C2.85778 5.90422 3.0499 6.50753 3.54051 6.76115C4.03112 7.01477 4.63443 6.82265 4.88805 6.33204C5.39949 5.3427 6.11185 4.47297 6.97143 3.7774ZM18.2861 2.22266C17.8568 1.87525 17.2271 1.94166 16.8797 2.37099C16.5323 2.80032 16.5987 3.42999 17.0281 3.7774C17.8913 4.47591 18.606 5.35004 19.1179 6.34457C19.3706 6.83562 19.9736 7.02881 20.4647 6.77605C20.9557 6.5233 21.1489 5.92033 20.8962 5.42927C20.256 4.18561 19.3633 3.09434 18.2861 2.22266ZM4.99982 10C4.99982 6.13404 8.13382 3.00003 11.9999 3.00003C15.8659 3.00003 18.9999 6.13404 18.9999 10V13.764L20.8219 17.4081C21.1876 18.1395 20.6558 19 19.8381 19H4.16162C3.3439 19 2.81206 18.1395 3.17775 17.4081L4.99982 13.764V10ZM8.99972 20H14.9998C14.9998 21.1046 14.1043 22 12.9998 22H10.9998C9.89516 22 8.99972 21.1046 8.99972 20Z",
		fill: "currentColor"
	})
});
export default SvgBellRingingFill;
